export default import.meta.ROLLDOWN_FILE_URL_KrMPfk13hYyF3bdfbXFwJA